function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconScan = function SvgIconScan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 3.999,
    x: 13.5,
    y: 6.499,
    stroke: props.color,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 1.999,
    x: 15.5,
    y: 15.498,
    stroke: props.color,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 1.999,
    x: 12.5,
    y: 12.498,
    stroke: props.color,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 3.999,
    x: 6.5,
    y: 6.499,
    stroke: props.color,
    strokeLinejoin: "round",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 3.999,
    x: 6.5,
    y: 13.498,
    stroke: props.color,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    strokeLinecap: "round",
    d: "M3 8.998V4.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437c.214-.11.494-.11 1.054-.11H9m6.5 0h3.9c.56 0 .84 0 1.054.11a1 1 0 0 1 .437.437C21 3.759 21 4.039 21 4.6v4.398m-18 6.5v3.899c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.436c.214.11.494.11 1.054.11H8m8 0h3.4c.56 0 .84 0 1.054-.11a1 1 0 0 0 .437-.436c.109-.215.109-.495.109-1.055v-3.899"
  }));
};
export default SvgIconScan;